import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const MEALS = [
  { key: "colazione", label: "Colazione" },
  { key: "pranzo", label: "Pranzo" },
  { key: "spuntino", label: "Spuntino" },
  { key: "cena", label: "Cena" },
];

export const toISO = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const todayISO = () => toISO(new Date());

export const fmtDate = (d, opts = { day: "2-digit", month: "short", year: "numeric" }) =>
  d ? new Date(`${d}T00:00:00`).toLocaleDateString("it-IT", opts) : "—";

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "";

export const ageFrom = (birth) => {
  if (!birth) return null;
  const b = new Date(`${birth}T00:00:00`);
  const n = new Date();
  let a = n.getFullYear() - b.getFullYear();
  if (n < new Date(n.getFullYear(), b.getMonth(), b.getDate())) a -= 1;
  return a;
};

export const fullName = (p) => (p ? `${p.first_name} ${p.last_name}` : "");

export const LINKS = {
  site: "https://www.nutrizionistasimonamarretta.it",
  instagram: "https://www.instagram.com/nutrizionistasimonamarretta?srtk=cHQ2NnNmMWRvOXhs",
  review: "https://g.page/r/CWLkc6jEZBOWEAg/review",
};
